export default __webpack_public_path__ + "static/media/background-biru-ornamen.01e0cfec.jpg";